"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _redux = require("redux");

var _reducer = _interopRequireDefault(require("settings-ui-sdk/Auth/reducer"));

var _reducer2 = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/reducer"));

var _reducer3 = _interopRequireDefault(require("settings-ui-sdk/Channels/reducer"));

var _reducer4 = _interopRequireDefault(require("settings-ui-sdk/Domains/reducer"));

var _reactRouterRedux = require("react-router-redux");

var _Notifications = _interopRequireDefault(require("ReduxMessenger/reducers/Notifications"));

var _reducer5 = _interopRequireDefault(require("settings-ui-sdk/Hubs/reducer"));

var _reducer6 = _interopRequireDefault(require("settings-ui-sdk/Iris/reducer"));

var _reducer7 = _interopRequireDefault(require("settings-ui-sdk/SiteSettings/reducer"));

var _reducer8 = _interopRequireDefault(require("settings-ui-sdk/Properties/reducer"));

var _reducer9 = _interopRequireDefault(require("settings-ui-sdk/UserAppAttributes/reducer"));

var _reducer10 = _interopRequireDefault(require("settings-ui-sdk/DesignTemplates/reducer"));

var _reducer11 = _interopRequireDefault(require("settings-ui-sdk/PortalSettings/reducer"));

var _reducer12 = _interopRequireDefault(require("settings-ui-sdk/Users/reducer"));

var _reducer13 = _interopRequireDefault(require("settings-ui-sdk/Owners/reducer"));

var _reducer14 = _interopRequireDefault(require("settings-ui-sdk/UserSettings/reducer"));

var _reducer15 = _interopRequireDefault(require("settings-ui-sdk/I18n/reducer"));

var _reducer16 = _interopRequireDefault(require("settings-ui-sdk/SupportedLanguages/reducer"));

var _reducer17 = _interopRequireDefault(require("settings-ui-sdk/OptIn/reducer"));

var _reducer18 = _interopRequireDefault(require("settings-ui-sdk/PagesForSitemaps/reducer"));

var _reducer19 = _interopRequireDefault(require("settings-ui-sdk/Themes/reducer"));

var _reducer20 = _interopRequireDefault(require("settings-ui-sdk/MultiCurrency/reducer"));

var _reducer21 = _interopRequireDefault(require("settings-ui-sdk/SitePages/reducer"));

var _reducer22 = _interopRequireDefault(require("settings-ui-sdk/Lists/reducer"));

var _GoogleFonts = _interopRequireDefault(require("ContentData/reducers/GoogleFonts"));

var _reducer23 = _interopRequireDefault(require("settings-ui-sdk/ContentMembership/reducer"));

var _reducer24 = _interopRequireDefault(require("settings-ui-sdk/MembershipEmails/reducer"));

var _reducer25 = _interopRequireWildcard(require("settings-content-modals/EmailCreationModal/reducer"));

var _reducer26 = _interopRequireDefault(require("settings-content-modals/propertyDefaultsModals/reducer"));

var _reducerNamespace = require("settings-content-modals/data/reducerNamespace");

var _default = function _default(rootModule) {
  var _combineReducers;

  return (0, _redux.combineReducers)((_combineReducers = {}, (0, _defineProperty2.default)(_combineReducers, _reducer25.reducerNamespace, _reducer25.default), (0, _defineProperty2.default)(_combineReducers, _reducerNamespace.reducerNamespace, _reducer26.default), (0, _defineProperty2.default)(_combineReducers, "auth", _reducer.default), (0, _defineProperty2.default)(_combineReducers, "channels", _reducer3.default), (0, _defineProperty2.default)(_combineReducers, "domains", _reducer4.default), (0, _defineProperty2.default)(_combineReducers, "routing", _reactRouterRedux.routerReducer), (0, _defineProperty2.default)(_combineReducers, "requests", _reducer2.default), (0, _defineProperty2.default)(_combineReducers, "notifications", _Notifications.default), (0, _defineProperty2.default)(_combineReducers, "modules", rootModule.reducer), (0, _defineProperty2.default)(_combineReducers, "hub", _reducer5.default), (0, _defineProperty2.default)(_combineReducers, "iris", _reducer6.default), (0, _defineProperty2.default)(_combineReducers, "designTemplates", _reducer10.default), (0, _defineProperty2.default)(_combineReducers, "siteSettings", _reducer7.default), (0, _defineProperty2.default)(_combineReducers, "portalSettings", _reducer11.default), (0, _defineProperty2.default)(_combineReducers, "multiCurrency", _reducer20.default), (0, _defineProperty2.default)(_combineReducers, "owners", _reducer13.default), (0, _defineProperty2.default)(_combineReducers, "users", _reducer12.default), (0, _defineProperty2.default)(_combineReducers, "userSettings", _reducer14.default), (0, _defineProperty2.default)(_combineReducers, "userAppAttributes", _reducer9.default), (0, _defineProperty2.default)(_combineReducers, "languageLocale", _reducer15.default), (0, _defineProperty2.default)(_combineReducers, "supportedLanguages", _reducer16.default), (0, _defineProperty2.default)(_combineReducers, "optIn", _reducer17.default), (0, _defineProperty2.default)(_combineReducers, "properties", _reducer8.default), (0, _defineProperty2.default)(_combineReducers, "pagesForSitemaps", _reducer18.default), (0, _defineProperty2.default)(_combineReducers, "themes", _reducer19.default), (0, _defineProperty2.default)(_combineReducers, "sitePages", _reducer21.default), (0, _defineProperty2.default)(_combineReducers, "contactLists", _reducer22.default), (0, _defineProperty2.default)(_combineReducers, "resources", (0, _redux.combineReducers)({
    googleFonts: _GoogleFonts.default
  })), (0, _defineProperty2.default)(_combineReducers, "listRegistrations", _reducer23.default), (0, _defineProperty2.default)(_combineReducers, "membershipEmails", _reducer24.default), _combineReducers));
};

exports.default = _default;
module.exports = exports.default;